import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import Vuetify from "vuetify";
import Moment from "moment";
Moment.locale("nl");

import "vuetify/dist/vuetify.min.css";
import "./registerServiceWorker";

Vue.use(Vuetify);

Vue.prototype.$moment = Moment;

Vue.use(require("vue-moment"));

Vue.config.productionTip = false;

window.dateFormatFriendly = function(d) {
  let date = new Date(d);
  return new Intl.DateTimeFormat("nl-NL", {
    dateStyle: "long"
  }).format(date);
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
